import React, { FC } from "react";
import "../styles.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/authContext";

const Menu: FC = () => {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    const handleLogout = async () => {
        await logout();
        nav("/", { replace: true});
    };

    return (
        <>
        <header className="topbar">
            <div className="container nav">
                <div><button type="button" className="nav-link" onClick={() => nav("/")}><img src={"/images/JobLens360-Logo.png"} width="175" alt="JobLens360" /></button></div>
                <div>{user ? `Welcome, ${user.displayName}` : ""}</div>
                <nav>
                    <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("/")}>Home</button>
                    {user ? <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("/recruiterworkspace")}>Workspace</button> : ""}
                    {user ? <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("/recruiterreview")}>Recruiter Review</button> : ""}
                    {user ? <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("/jobpostings/new")}>Add Job</button> : ""}
                    {user ? <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("/candidatecomparison")}>Candidate Compare</button> : ""}
                    {user ? <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("settings")}>Settings</button> : ""}
                    { !user ? (
                        <button type="button" className="nav-link" style={{ padding: "5px" }} onClick={() => nav("login")}>Login</button>
                    ) : (<button type="button" className="nav-link" style={{ padding: "5px" }} onClick={user ? handleLogout : undefined}>Logout</button>)}
                </nav>
            </div>
        </header>
        </>
    );
}

export default Menu;
